import type { AgendaEventWorkLocationItemProps } from "./components/AgendaEventWorkLocationItem";
import type WorkLocationsSurfaceItemProps from "./components/WorkLocationsSurfaceItemProps";
import type * as lazyIndex from "./lazyIndex";
import { createLazyComponent, LazyAction, type LazyComponent, LazyModule } from "owa-bundling";

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(() => import(/* webpackChunkName: "WorkLocationSurfaceItem" */ "./lazyIndex"), { name: "WorkLocationSurfaceItem" });

// Lazy-load components
export const WorkLocationsSurfaceItem: LazyComponent<WorkLocationsSurfaceItemProps, unknown, void> = createLazyComponent(lazyModule, m => m.WorkLocationsSurfaceItem);

export const lazyGetWorkingHoursViewGraphQL: LazyAction<typeof lazyIndex.getWorkingHoursViewGraphQL, typeof lazyModule> = new LazyAction(lazyModule, m => m.getWorkingHoursViewGraphQL);

export const lazyIsWorkLocationControlTypeEnabled: LazyAction<typeof lazyIndex.isWorkLocationControlTypeEnabled, typeof lazyModule> = new LazyAction(lazyModule, m => m.isWorkLocationControlTypeEnabled);

export const AgendaEventWorkLocationItem: LazyComponent<AgendaEventWorkLocationItemProps, unknown, void> = createLazyComponent(lazyModule, m => m.AgendaEventWorkLocationItem);
